<template> 
  <div class="overwrapper">
    <div class="wrapper">   
      <div   
      :style="{'margin-left':'-'+ (100*currentSlideIndex)+ '%'}"
      class="vcarousel" 
      >
      <v-carousel-item   
        v-for="item in carousel_data"
        :key="item.id"
        :item_data="item"
        />     
      </div> 

    </div>
    <v-slider-controls
      @prev="prevSlide" 
      @next="nextSlide"
    /> 
  </div>

</template>

<script>
import vCarouselItem from './v-carousel-item.vue'
import vSliderControls from './v-slider-controls.vue'
export default { 
 components: {
  vCarouselItem,
  vSliderControls
 },
 props: {
  carousel_data:{
   type: Array,
   default: ()=>[]
  },
  interval:{
   type: Number,
   default:0
  }
 },
 data(){
  return{
   currentSlideIndex: 0,
  }
 },
 mounted(){
  if (this.interval>0) {
   let vm=this;
   setInterval(function(){
    vm.nextSlide()
   },vm.interval)
  }
 },
 methods:{
  prevSlide(){
    if(this.currentSlideIndex > 0){
     this.currentSlideIndex--
    }
    console.log(this.currentSlideIndex)
  },
  nextSlide(){
   if(this.currentSlideIndex >=this.carousel_data.length-1){
    this.currentSlideIndex=0
   } else{
    this.currentSlideIndex++
   }
     
  },
 },
 
}
</script>

<style lang="sass" scoped>

  .overwrapper
    position: relative
    width: 100%
    max-width: 960px
    
  .wrapper
    width: 800px
    overflow: hidden
    margin: 0 auto 
    position: relative 
    .vcarousel        
      display: flex
      transition: all ease .5s
      width: 800px

  @media screen and (max-width: 700px)
    .overwrapper
      .wrapper
        width: 500px
        .vcarousel
          width: 500px
    
  @media screen and (max-width: 630px)
    .overwrapper
        .wrapper
          width: 300px
          .vcarousel
            width: 300px
  
 

</style>